import React, { useState, useEffect } from "react";
import { createStore } from "redux";
import { Provider } from "react-redux";
import AppRouter from "./Route/Routes";
import rootReducer from "./Reducer/RootReducer";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { PersistGate } from "redux-persist/integration/react";
import { Allcontext } from "./Container/Context/Allcontext";
const App = () => {
  // let store = createStore(rootReducer);
  const persistConfig = {
    key: "root",
    storage,
  };
  const persistedReducer = persistReducer(persistConfig, rootReducer);

  let store = createStore(persistedReducer);
  let persistor = persistStore(store);
  return (
    <div className="App">
      <Provider store={store}>
        <Allcontext>
          <PersistGate loading={null} persistor={persistor}>
            <AppRouter />
          </PersistGate>
        </Allcontext>
      </Provider>
    </div>
  );
};

export default App;
